import { inject, IEventAggregator, bindable } from 'aurelia';
import { AddGroupItem } from '../../messages/add-group-item';

@inject(Element, IEventAggregator)
export class AddGroupItemCustomAttribute {
  @bindable value;

  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
    this.onClick = (event) => {
      event.preventDefault();
      this.ea.publish(new AddGroupItem(this.value));
    };
  }

  attached() {
    this.element.addEventListener('click', this.onClick);
  }

  detaching() {
    this.element.removeEventListener('click', this.onClick);
  }
}
